import * as React from "react";
import Input from "../Input-new/Input";

const TenantInfo = ({ data, handleChangeInput, viewMode, deleted }) => {
  return (
    <div className="Tenant-info">
      <div className="Tenant-info_column">
        <Input
          className="Tenant-info_column_item"
          required
          valueType="text"
          name="NAME"
          label="NAME"
          value={data.NAME}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
      </div>
    </div>
  );
};

export default TenantInfo;
